import { Component } from '@verndale/core';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { isIE } from '../helpers';

class Module extends Component {
  setupDefaults() {
    if (isIE) return;
    gsap.registerPlugin(ScrollTrigger);

    this.dom = {
      bigCardCard: this.el.querySelector('.cta-grouping__main-card'),
      bigCardContent: this.el.querySelector(
        '.cta-grouping__main-card .cta-grouping__card-content'
      ),
      bigCardImage: this.el.querySelector(
        '.cta-grouping__main-card .cta-grouping__card-image'
      ),
      smallCards: [...this.el.querySelectorAll('.card')]
    };

    ScrollTrigger.matchMedia({
      '(min-width: 1280px)': this.initParallax.bind(this),
      '(max-width: 1279px)': this.disableParallax.bind(this)
    });
  }

  initParallax() {
    gsap.from(this.dom.bigCardContent, {
      scrollTrigger: {
        trigger: this.dom.bigCardCard,
        end: 'top top',
        scrub: true
      },
      alpha: 0,
      x: -180
    });

    gsap.from(this.dom.bigCardImage, {
      scrollTrigger: {
        trigger: this.dom.bigCardCard,
        end: 'top top',
        scrub: true
      },
      alpha: 0,
      x: 180
    });

    this.dom.smallCards.forEach((card, index) => {
      gsap.set(card, { y: index ? 0 : -108 });
      gsap.from(card, {
        scrollTrigger: {
          trigger: card,
          end: 'top 30%',
          scrub: true
        },
        alpha: 0,
        y: 70
      });
    });

    setTimeout(() => ScrollTrigger.refresh(), 0);
  }

  disableParallax() {
    gsap.set(this.dom.bigCardContent, { alpha: 1, x: 0 });
    gsap.set(this.dom.bigCardImage, { alpha: 1, x: 0 });
    this.dom.smallCards.forEach(card => gsap.set(card, { alpha: 1, y: 0 }));
  }
}

export default Module;
